(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5978],{

/***/ 40476:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-conditions",
      function () {
        return __webpack_require__(28445);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 28445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37672);
/* harmony import */ var _src_landingPage_views_LegalPages_template_LegalTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3286);



var TermsPage = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_1__/* .NextHead */ .B, {
                currentPath: "/terms-and-conditions",
                title: "Website Use Terms & Conditions"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_landingPage_views_LegalPages_template_LegalTemplate__WEBPACK_IMPORTED_MODULE_2__/* .LegalTemplate */ .K, {
                children: content
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (TermsPage);


/***/ }),

/***/ 37672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NextHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34631);
/* harmony import */ var _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79550);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var NextHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, pageImageUrl = param.pageImageUrl, pageImageWidth = param.pageImageWidth, pageImageHeight = param.pageImageHeight, canonical = param.canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 75);
    var formattedDescription = description.length && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + currentPath;
    var canonicalUrl = canonical ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        return originUrl + _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context":"https://schema.org",\n            "@graph": [\n              {\n                "@type":"Organization",\n                "name":"Demyst",\n                "url":"'.concat(originUrl, '",\n                "logo":"').concat(originUrl + _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, '",\n                "sameAs":[\n                  "https://twitter.com/demystdata",\n                  "https://www.linkedin.com/company/demystdata"\n                ]\n              },\n              {\n                "@type":"WebSite",\n                "@id":"').concat(originUrl, '/#website",\n                "url":"').concat(originUrl, '",\n                "name":"Demyst",\n                "inLanguage":"en-US"\n              },\n              {\n                "@type":"WebPage",\n                "@id":"').concat(currentUrl, '#webpage",\n                "url":"').concat(currentUrl, '",\n                "name":"').concat(formattedTitle, '",\n                "isPartOf":{\n                  "@id":"').concat(originUrl, '/#website"\n                },\n                "inLanguage":"en-US",\n                ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n                "potentialAction":[\n                  {\n                    "@type":"ReadAction",\n                    "target":[\n                      "').concat(currentUrl, '"\n                    ]\n                  },\n                  {\n                    "@type": "SearchAction",\n                    "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                ]\n              }\n            ]\n          }')
                }
            }),
            children
        ]
    });
};
NextHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    sendPageView: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ }),

/***/ 3286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ LegalTemplate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var LegalTemplate = function(param) {
    var embed = param.embed, children = param.children;
    if (embed) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "legal-main",
            dangerouslySetInnerHTML: {
                __html: children
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "legal-background",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "section-layout",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "legal-main legal-main_paper",
                dangerouslySetInnerHTML: {
                    __html: children
                }
            })
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(40476); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);